import { Empty, Input, Tooltip, Select, Pagination } from "antd";
import { convertToObjectKeyString, TranslateString } from "Utils/Common";
import { UndoOutlined, EditOutlined, SelectOutlined } from "@ant-design/icons";
import { useNavigate, Link } from "react-router-dom";
import moment from "moment";
import { TenderStatus } from "constants/Constants";
import { BsArrowDownUp } from "react-icons/bs";
import { useIntl } from "react-intl";
import { useState } from "react";

function OpenLoanTenderingCase(props: any) {
  const intl = useIntl();
  const navigate = useNavigate();
  //   const [openSearchData, setOpenSearchData] = useState<any>(
  //     props?.openSearchData || {}
  //   );

  //   const onSearch = (event: any) => {
  //     const { target } = event;
  //     const value = target.value;
  //     const { name } = target;

  //     setOpenSearchData({ ...openSearchData, [name]: value });
  //   };

  //   const onPressEnter = (event: any) => {
  //     props.setOpenSearchData({ ...openSearchData });
  //   };

  const [openSearchData, setOpenSearchData] = useState<any>(
    props?.openSearchData || {},
  );

  const onSearch = (e: any) => {
    const { name, value } = e.target;

    props.setOpenSearchData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onPressEnter = () => {
    props.setOpenSearchData((prev: any) => ({ ...prev }));
  };

  return (
    <>
      {/* <div className="cu-table-border"> */}
       <div id="open-loan-section"  className="cu-table-border">
        <table className="table table-sm table-bordered table-striped text-left">
          <thead>
            <tr>
              <td colSpan={17} className="bg-white fw-bold fs-4">
                {TranslateString("Open loan tendering case")}
              </td>
            </tr>
            <tr className="align-middle cu-text-small">
              <td className="cu-bg-green fw-bold cu-three-width text-center">
                {TranslateString("priority")}
              </td>
              <td className="cu-bg-green fw-bold cu-three-width text-center">
                {TranslateString("tender_id")}
              </td>
              <td className="cu-bg-green fw-bold cu-three-width text-center">
                {TranslateString("customer_id")}
              </td>
              <td className="cu-bg-green fw-bold">
                {TranslateString("customer_name")}
              </td>
              <td className="cu-bg-green fw-bold">
                {TranslateString("loan_name")}
              </td>
              <td className="cu-bg-green fw-bold">
                {TranslateString("loan_invoicing_model")}
              </td>
              <td className="cu-bg-green fw-bold cu-seven-width text-right">
                {TranslateString("current_capital")}
              </td>
              <td className="cu-bg-green fw-bold cu-five-width text-right">
                {TranslateString("margin")}
              </td>
              <td className="cu-bg-green fw-bold cu-three-width">
                {TranslateString("loaner_grouped")}
              </td>
              <td className="cu-bg-green fw-bold cu-three-width">
                {TranslateString("city")}
              </td>
              <td className="cu-bg-green fw-bold">
                {TranslateString("sännöitsijä")}
              </td>
              {/* <td className="cu-bg-green fw-bold">
                {TranslateString("housing_manager_comment")}
              </td> */}
              {/* <td className="cu-bg-green fw-bold">
                {TranslateString("Kirjanpitäjä")}
              </td> */}
              <td className="cu-bg-green fw-bold">
                {TranslateString("Moderaattori")}
              </td>
              <td className="cu-bg-green fw-bold">
                {TranslateString("status")}
              </td>
              <td className="cu-bg-green fw-bold">
                {TranslateString("deadline")}
              </td>
              <td className="cu-bg-green fw-bold cu-ten-width">
                {TranslateString("tendering_notes")}
              </td>
              <td className="cu-bg-green fw-bold cu-three-width">
                {TranslateString("number_of_tenders_received")}
              </td>
              <td className="cu-bg-green fw-bold">
                {TranslateString("actions")}
              </td>
            </tr>
            <tr className="align-middle cu-text-small">
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setOpenSearchData({
                          ...props.openSearchData,
                          sort_by: "loan_data_priority",
                        });
                        props.setOpenSort(!props.openSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_data_priority"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.openSearchData.loan_tender_id || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setOpenSearchData({
                          ...props.openSearchData,
                          sort_by: "loan_tender_id",
                        });
                        props.setOpenSort(!props.openSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_tender_id"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.openSearchData.loan_data_customerid || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setOpenSearchData({
                          ...props.openSearchData,
                          sort_by: "loan_data_customerid",
                        });
                        props.setOpenSort(!props.openSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_data_customerid"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.openSearchData.loan_data_customername || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setOpenSearchData({
                          ...props.openSearchData,
                          sort_by: "loan_data_customername",
                        });
                        props.setOpenSort(!props.openSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_data_customername"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.openSearchData.loan_data_name || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setOpenSearchData({
                          ...props.openSearchData,
                          sort_by: "loan_data_name",
                        });
                        props.setOpenSort(!props.openSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_data_name"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.openSearchData.loan_invoicing_model || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setOpenSearchData({
                          ...props.openSearchData,
                          sort_by: "loan_invoicing_model",
                        });
                        props.setOpenSort(!props.openSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_invoicing_model"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.openSearchData.loan_data_agreement || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setOpenSearchData({
                          ...props.openSearchData,
                          sort_by: "loan_data_agreement",
                        });
                        props.setOpenSort(!props.openSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_data_agreement"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.openSearchData.loan_data_margin || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setOpenSearchData({
                          ...props.openSearchData,
                          sort_by: "loan_data_margin",
                        });
                        props.setOpenSort(!props.openSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_data_margin"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.openSearchData.loan_data_bank_group || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setOpenSearchData({
                          ...props.openSearchData,
                          sort_by: "loan_data_bank_group",
                        });
                        props.setOpenSort(!props.openSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_data_bank_group"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.openSearchData.cust_data_city || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setOpenSearchData({
                          ...props.openSearchData,
                          sort_by: "cust_data_city",
                        });
                        props.setOpenSort(!props.openSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="cust_data_city"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.openSearchData.cust_data_manager_name || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setOpenSearchData({
                          ...props.openSearchData,
                          sort_by: "cust_data_manager_name",
                        });
                        props.setOpenSort(!props.openSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="cust_data_manager_name"
                />
              </td>
              {/* <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.openSearchData.hm_comment || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setOpenSearchData({
                          ...props.openSearchData,
                          sort_by: "hm_comment",
                        });
                        props.setOpenSort(!props.openSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="hm_comment"
                />
              </td> */}
              {/* <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.openSearchData.accountant_name || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setOpenSearchData({
                          ...props.openSearchData,
                          sort_by: "accountant_name",
                        });
                        props.setOpenSort(!props.openSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="accountant_name"
                />
              </td> */}
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.openSearchData.created_by || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setOpenSearchData({
                          ...props.openSearchData,
                          sort_by: "created_by",
                        });
                        props.setOpenSort(!props.openSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="created_by"
                />
              </td>
              <td className="cu-bg-green" width={100}>
                <Select
                  placeholder={TranslateString("select")}
                  value={props.openSearchData.status || ""}
                  showSearch
                  className="w-100"
                  onChange={(value: any) => {
                    setOpenSearchData({ ...openSearchData, status: value });
                    props.setOpenSearchData({
                      ...props.openSearchData,
                      status: value,
                    });
                  }}
                  options={[
                    ...TenderStatus.map(({ value, label }) => {
                      return {
                        value: value,
                        label: intl.formatMessage({
                          id: convertToObjectKeyString(value),
                        }),
                      };
                    }),
                  ]}
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.openSearchData.loan_tender_deadline || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setOpenSearchData({
                          ...props.openSearchData,
                          sort_by: "loan_tender_deadline",
                        });
                        props.setOpenSort(!props.openSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_tender_deadline"
                />
              </td>
              <td className="cu-bg-green">
                <Input
                  placeholder={TranslateString("search")}
                  value={props.openSearchData.loan_tender_notes || ""}
                  suffix={
                    <BsArrowDownUp
                      onClick={() => {
                        props.setOpenSearchData({
                          ...props.openSearchData,
                          sort_by: "loan_tender_notes",
                        });
                        props.setOpenSort(!props.openSort);
                      }}
                      role={"button"}
                    />
                  }
                  onChange={onSearch}
                  onPressEnter={onPressEnter}
                  name="loan_tender_notes"
                />
              </td>
              <td className="cu-bg-green"></td>
              <td className="cu-bg-green"></td>
            </tr>
          </thead>
          <tbody className="cu-text-small">
            {props?.tenderData?.getOpenTender?.length > 0 ? (
              props?.tenderData?.getOpenTender?.map((val: any) => {
                return (
                  <tr>
                    <td className="text-center fw-bold">
                      {val?.LOAN_DATA?.loan_data_priority || "-"}
                    </td>
                    <td className="text-center fw-bold">
                      {val?.loan_tender_id || "-"}
                    </td>
                    <td
                      className="text-center fw-bold cu-link"
                      role="button"
                      onClick={() => {
                        navigate(
                          "/single-loan/" +
                            val?.LOAN_DATA?.loan_data_customerid +
                            "/" +
                            val?.loan_tender_id,
                        );
                      }}
                    >
                      {val?.LOAN_DATA?.loan_data_customerid || "-"}
                    </td>
                    <td>{val?.LOAN_DATA?.loan_data_customername || "-"}</td>
                    <td>
                      {val?.LOAN_DATA?.loan_data_name?.replace(
                        "Uusi laina:",
                        TranslateString("new_loan"),
                      ) || "-"}
                    </td>
                    <td className="text-center">
                      {val?.LOAN_DATA?.loan_invoicing_model || "-"}
                    </td>
                    <td className="text-right fw-bold text-nowrap">
                      {val?.LOAN_DATA?.loan_data_agreement || "-"}
                    </td>
                    <td className="text-right fw-bold text-nowrap">
                      {val?.LOAN_DATA?.loan_data_margin || "-"}
                    </td>
                    <td>{val?.LOAN_DATA?.loan_data_bank_group || "-"}</td>
                    <td>{val?.LOAN_DATA?.CUST_DATA?.cust_data_city || "-"}</td>
                    <td>
                      {val?.LOAN_DATA?.CUST_DATA?.cust_data_manager_name || "-"}
                    </td>
                    {/* <td>{val?.hm_comment || "-"}</td> */}
                    {/* <td>{val?.LOAN_DATA?.CUST_DATA?.accountant_name || "-"}</td> */}
                    <td>{val?.created_by || "-"}</td>
                    <td>
                      {val?.loan_tender_status
                        ? intl.formatMessage({
                            id: convertToObjectKeyString(
                              val?.loan_tender_status,
                            ),
                          })
                        : "-"}
                    </td>
                    <td>
                      {val?.loan_tender_deadline
                        ? moment(val?.loan_tender_deadline).format("DD.MM.YYYY")
                        : "-"}
                    </td>
                    <td>{val?.loan_tender_notes || "-"}</td>
                    <td className="text-center fw-bold">
                      {val?.no_of_tenders_received || "-"}
                    </td>
                    <td className="text-center" role="button">
                      <div className="d-flex">
                        <div>
                          <Tooltip title={TranslateString("select")}>
                            <Link
                              to={
                                "/single-loan/" +
                                val?.LOAN_DATA?.loan_data_customerid +
                                "/" +
                                val?.loan_tender_id
                              }
                            >
                              <SelectOutlined className="m-0 cu-font-bold cu-font-select" />
                            </Link>
                          </Tooltip>
                        </div>
                        <div>&nbsp;</div>
                        <div>
                          <Tooltip title={TranslateString("revert")}>
                            <UndoOutlined
                              onClick={() => props.handleRevert(val)}
                              className="m-0 cu-font-bold cu-font-cancel"
                            />
                          </Tooltip>
                        </div>
                        <div>&nbsp;</div>
                        <div>
                          <Tooltip title={TranslateString("edit")}>
                            <EditOutlined
                              className="fs-5"
                              onClick={() => {
                                props.setDeadlineRequired(false);
                                props.setNotesRequired(false);
                                props.handleEdit(val);
                              }}
                            />
                          </Tooltip>
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={17}>
                  <Empty description={TranslateString("Empty")} />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* <div className="d-flex justify-content-end mt-3">
        <div>
          {`${(props.openPageData?.page || 0) * (props.openPageData?.size || 50) + 1}
      -
      ${Math.min(
        ((props.openPageData?.page || 0) + 1) *
          (props.openPageData?.size || 50),
        props.openTotalRecords || 0,
      )}
      of ${props.openTotalRecords || 0} items`}
        </div>
        <Pagination
          current={(props.openPageData?.page || 0) + 1}
          pageSize={props.openPageData?.size || 50}
          total={props.openTotalRecords || 0}
          showSizeChanger
          pageSizeOptions={[10, 20, 50, 100]}
          onChange={(page, pageSize) => {
            document.getElementById("open-loan-section")?.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });

            props.setOpenPageData({
              page: page - 1,
              size: pageSize,
            });
          }}
          onShowSizeChange={(_, size) => {
            document.getElementById("open-loan-section")?.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });

            props.setOpenPageData({
              page: 0,
              size,
            });
          }}
        />
      </div> */}
        {/* <div  className="d-flex justify-content-end mt-3"> */}
       <div  className="d-flex justify-content-end align-items-center gap-3 mt-3">
         {/* <div>
    {`${((props.openPageData?.page || 0) * (props.openPageData?.size || 50)) + 1}
      -
      ${Math.min(
        ((props.openPageData?.page || 0) + 1) *
          (props.openPageData?.size || 50),
        props.openTotalRecords || 0
      )}
      of ${props.openTotalRecords || 0} items`}
  </div> */}
  {/* <Pagination
  current={(props.openPageData?.page || 0) + 1}
  pageSize={props.openPageData?.size || 50}
  total={props.openTotalRecords || 0}
  showSizeChanger
  pageSizeOptions={[10,20,50, 100]}
   onChange={(page, pageSize) => {
      document
        .getElementById("open-loan-section")
        ?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

      props.setOpenPageData({
        page: page - 1,
        size: pageSize,
      });
    }}
    onShowSizeChange={(_, size) => {
      document
        .getElementById("open-loan-section")
        ?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

      props.setOpenPageData({
        page: 0,
        size,
      });
    }}
/> */}
<div>
    {props.openPageData?.size === -1
      ? `1 - ${props.openTotalRecords} of ${props.openTotalRecords} items`
      : `${((props.openPageData?.page || 0) * (props.openPageData?.size || 50)) + 1}
        -
        ${Math.min(
          ((props.openPageData?.page || 0) + 1) *
            (props.openPageData?.size || 50),
          props.openTotalRecords || 0
        )}
        of ${props.openTotalRecords || 0} items`}
  </div>


  <Pagination
    current={
      props.openPageData?.size === -1
        ? 1
        : (props.openPageData?.page || 0) + 1
    }
    pageSize={
      props.openPageData?.size === -1
        ? props.openTotalRecords
        : props.openPageData?.size
    }
    total={props.openTotalRecords || 0}
    showSizeChanger={false}
    onChange={(page) => {
      document
        .getElementById("open-loan-section")
        ?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });

      props.setOpenPageData({
        page: page - 1,
        size: props.openPageData?.size,
      });
    }}
  />
  <Select
  style={{ width: 100 }}
  value={props.openPageData?.size}
  onChange={(value) => {
    document
      .getElementById("open-loan-section")
      ?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

    props.setOpenPageData({
      page: 0,
      size: value,
    });
  }}
  options={[
    { label: "10", value: 10 },
    { label: "20", value: 20 },
    { label: "50", value: 50 },
    { label: "100", value: 100 },
    { label: "All", value: -1 },
  ]}
/>
</div>

    </>
  );
}
export default OpenLoanTenderingCase;
